<template>
  <div class="centerPage">
    <div class="centerPage_bigTitle">
      <a href="/">
        <img src="~images/logo.svg" alt="" />
      </a>
      Log in to EZ Retro
    </div>
    <div class="centerPage_whiteBox whiteBox">
      <form v-if="!showForgotPassword">
        <label>Email</label>
        <input class="input" name="username" v-model.trim="loginForm.email" placeholder="john@appleseed.com" type="email" autocomplete="username email" />

        <label>Password</label>
        <input class="input" name="password"  v-model.trim="loginForm.password" placeholder="••••••••••••" type="password" autocomplete="password"/>

        <div v-if="errorMsg !== ''" class="error-msg">
          {{ errorMsg }}
        </div>
        <button class="loginBox_textButton" type="button" @click="togglePasswordReset">
          Forgot password?
        </button>
        <button type="button" @click="login" :disabled="loading" v-bind:class="[loading ? 'loading' : '', 'button']">
          Log in
        </button>
      </form>
      <form v-else>
        <div v-if="!passwordResetSuccess">
          <label>Email</label>
          <input  class="input" v-model.trim="passwordForm.email" type="email" placeholder="john@appleseed.com" autocomplete="username email" />

          <div v-if="errorMsg !== ''" class="error-msg">
            {{ errorMsg }}
          </div>

          <button class="loginBox_textButton" type="button" @click="togglePasswordReset">
            Back to Log in
          </button>

          <button :disabled="loading" type="button" @click="resetPassword" v-bind:class="[loading ? 'loading' : '', 'button']">
            Submit
          </button>
        </div>
        <div v-else>
          <p class="loginText_title">Email Sent</p>
          <p class="loginText_text">
            check your email for a link to reset your password
          </p>
          <button @click="togglePasswordReset" class="loginBox_textButton">
            Back to login
          </button>
        </div>
      </form>
    </div>
    <div class="centerPage_whiteBox centerPage_whiteBox_additional">
      New to EZ Retro?
      <router-link to="signup">
        Get started
      </router-link>
    </div>
  </div>
</template>

<script>
import { AUTH, ANALYTICS } from 'src/firebase-config';
export default {
  data() {
    return {
      loginForm: {
        email: '',
        password: ''
      },
      passwordForm: {
        email: ''
      },
      loading: false,
      showForgotPassword: false,
      passwordResetSuccess: false,
      errorMsg: ''
    };
  },
  methods: {
    login() {
      this.loading = true;
      AUTH.signInWithEmailAndPassword(this.loginForm.email, this.loginForm.password)
        .then(user => {
          this.$store.commit('setCurrentUser', user);
          this.loading = false;
          ANALYTICS.logEvent('user_login',{
            email:this.loginForm.email,
          });
          this.$router.push('/');
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
          this.errorMsg = err.message;
        });
    },
    togglePasswordReset() {
      if (this.showForgotPassword) {
        this.showForgotPassword = false;
        this.passwordResetSuccess = false;
      } else {
        this.showForgotPassword = true;
      }
    },
    resetPassword() {
      this.loading = true;
      AUTH.sendPasswordResetEmail(this.passwordForm.email)
        .then(() => {
          this.loading = false;
          this.passwordResetSuccess = true;
          this.passwordForm.email = '';
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
          this.errorMsg = err.message;
        });
    }
  },
  beforeMount() {
    if (AUTH.currentUser) {
      this.$router.push('/dashboard');
    }
  },
  mounted() {
    ANALYTICS.logEvent('page_view');
  }
};
</script>

<style></style>
